import { render, staticRenderFns } from "./MoneyTotalCard.vue?vue&type=template&id=1f27a5ca&scoped=true"
import script from "./MoneyTotalCard.vue?vue&type=script&lang=js"
export * from "./MoneyTotalCard.vue?vue&type=script&lang=js"
import style0 from "./MoneyTotalCard.vue?vue&type=style&index=0&id=1f27a5ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f27a5ca",
  null
  
)

export default component.exports